import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { graphql, createFragmentContainer } from 'react-relay';
import SV from 'server-vars';

import { Button } from 'dibs-elements/exports/Button';

import { PdpSharedContactSupportButton_user } from './__generated__/PdpSharedContactSupportButton_user.graphql';
import { PdpSharedContactSupportButton_item } from './__generated__/PdpSharedContactSupportButton_item.graphql';

type Props = {
    user: PdpSharedContactSupportButton_user;
    item: PdpSharedContactSupportButton_item;
};

export const PdpSharedContactSupportButtonComponent: FC<Props> = ({ user, item }) => {
    const contact1stdibs = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.contact1stdibs"
            defaultMessage="Contact 1stdibs"
        />
    );
    let supportUrl: string;

    if (SV.get('locale') === 'de-DE') {
        const { dibsReference } = item;
        const profile = user?.profile;
        const queryStringData = [];
        if (dibsReference) {
            queryStringData.push(['tfa_6980290243422', dibsReference]);
        }
        if (profile) {
            const { displayName, email } = profile;
            if (displayName) {
                queryStringData.push(['tfa_EmailAddress', displayName]);
            }
            if (email) {
                queryStringData.push(['tfa_Addresscontinued', email]);
            }
        }
        const encodedQueryString = new URLSearchParams(queryStringData);
        supportUrl = `/contact/de/?${encodedQueryString.toString()}`;
    } else {
        supportUrl = 'https://support.1stdibs.com/s/';
    }

    return (
        <Button
            type="secondary"
            dataTn="item-actions-contact-1stdibs-support"
            size="small"
            fullWidth
            onClick={() => window.open(supportUrl)} // opens in new tab
        >
            {contact1stdibs}
        </Button>
    );
};

export const PdpSharedContactSupportButton = createFragmentContainer(
    PdpSharedContactSupportButtonComponent,
    {
        user: graphql`
            fragment PdpSharedContactSupportButton_user on User {
                profile {
                    displayName
                    email
                }
            }
        `,
        item: graphql`
            fragment PdpSharedContactSupportButton_item on Item {
                dibsReference
            }
        `,
    }
);
